<script>
import axios from 'axios';
import router from '@/router';
/*import logoutButton from './logout-button';*/
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';

import { required, sameAs, email } from 'vuelidate/lib/validators';

export default {
	page: {
		title: 'Volunteer System',
		meta: [
			{
				name: 'Volunteer System',
			},
		],
	},
	components: { /*logoutButton ,*/ Header, Footer },
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			userData: JSON.parse(localStorage.getItem('web_user')),
			userRoles: JSON.parse(localStorage.getItem('selectedRoles')),
			isShow: false,
			isError: false,
			isSuccess: false,
			isDisable: false,
			type: 'password',
			typeConfirm: 'password',
			btnIcon: 'bx-show-alt',
			btnConfirmIcon: 'bx-show-alt',
			responseMessage: '',
			createAccount: {
				email: '',
				confirm_email: '',
				username: '',
				password: '',
				confirm_password: '',
				user_type_id: null,
				location_id: null,
			},
			dataForm: [],
			typeSubmit: false,
		};
	},
	validations: {
		createAccount: {
			email: { required, email },
			confirm_email: { required, sameAsEmail: sameAs('email') },
			password: { required },
			confirm_password: { required, sameAsPassword: sameAs('password') },
			user_type_id: {},
			location_id: {},
		},
	},
	mounted() {
		console.log(this.userRoles);
	},
	methods: {
		contactInfo() {
			router.push({ name: 'contact-info' });
		},

		addUserForm() {
			this.typeSubmit = true;
			this.isDisable = true;
			// stop here if form is invalid
			this.$v.$touch();
			if (!this.$v.$invalid) {
				const userData = JSON.parse(localStorage.getItem('web_user'));
				this.createAccount.user_type_id = userData['user_type_id'];
				this.createAccount.location_id += userData['location_id'];
				this.isSuccess = false;
				this.isShow = false;
				this.isError = false;
				this.createAccount.username = this.createAccount.email;
				axios
					.post('user/signup', this.createAccount)
					.then((res) => {
						this.isDisable = false;
						userData.token = res.data.response.token;
						userData.id = res.data.response.id;
						localStorage.setItem('web_user', JSON.stringify(userData));
						if (userData.token) {
							this.isSuccess = true;
							this.isShow = false;
							this.isError = false;
							if (userData.user_type_id === 3) {
								this.$bvModal.show('beforeBegin');
							} else {
								router.push({ name: 'contact-info' });
							}
						}
					})
					.catch((err) => {
						if (err.response) {
							this.isDisable = false;
							this.responseMessage = err.response.data.error.message[0];
							this.isShow = true;
							this.isError = true;
						}
					});
			}
			this.isDisable = false;
		},

		showPassword() {
			if (this.type === 'password') {
				this.type = 'text';
				this.btnIcon = 'bx-x';
			} else {
				this.type = 'password';
				this.btnIcon = 'bx-show-alt';
			}
		},

		showConfirmPassword() {
			if (this.typeConfirm === 'password') {
				this.typeConfirm = 'text';
				this.btnConfirmIcon = 'bx-x';
			} else {
				this.typeConfirm = 'password';
				this.btnConfirmIcon = 'bx-show-alt';
			}
		},

		becomeMentor() {
			this.isSuccess = false;
			this.isShow = false;
			this.isError = false;
			var userData = JSON.parse(localStorage.getItem('web_user'));
			var config = {
				headers: { Authorization: 'Bearer ' + userData.token },
			};
			axios
				.get('user/become/mentor?is_mentor=1', config)
				.then((res) => {
					if (res.status == 200) {
						const userData = JSON.parse(localStorage.getItem('web_user'));
						userData.is_mentor = true;
						localStorage.setItem('web_user', JSON.stringify(userData));
						router.push({ name: 'contact-info' });
					}
				})
				.catch((err) => {
					if (err.response) {
						this.responseMessage = err.response.data.error.message[0];
						this.isShow = true;
						this.isError = true;
					}
				});
		},
	},
};
</script>

<template>
	<div>
		<Header></Header>
		<section id="create-account">
			<div class="container">
				<div class="row">
					<div class="col-12 text-center">
						<h3 class="title">Create an account to begin your application</h3>
						<p>Already have an account?</p>
						<a href="/volunteer-system/login" class="">SIGN IN</a>
					</div>
				</div>
				<div class="row justify-content-center">
					<div class="col col-md-5">
						<form @submit.prevent="addUserForm" class="custom-form">
							<div class="mb-3">
								<div v-show="isShow" class="alert" :class="isError ? 'alert-danger' : isSuccess ? 'alert-success' : ''">
									{{ responseMessage }}
								</div>
							</div>
							<div class="mb-4">
								<input v-model="createAccount.email" type="text" class="form-control" placeholder="Enter Email Address" name="email" :class="{ 'is-invalid': typeSubmit && $v.createAccount.email.$error }" />
								<div v-if="typeSubmit && $v.createAccount.email.$error" class="invalid-feedback">
									<span v-if="!$v.createAccount.email.required">Email is required.</span>
									<span v-if="!$v.createAccount.email.email">Invalid email.</span>
								</div>
							</div>
							<div class="mb-4">
								<input v-model="createAccount.confirm_email" type="text" class="form-control" placeholder="Confirm Email Address" name="confirm_email" :class="{ 'is-invalid': typeSubmit && $v.createAccount.confirm_email.$error }" />
								<div v-if="typeSubmit && $v.createAccount.confirm_email.$error" class="invalid-feedback">
									<span v-if="!$v.createAccount.confirm_email.required">Confirm Email is required.</span>
									<span v-else-if="!$v.createAccount.confirm_email.sameAsEmail">This value should be the same as email.</span>
								</div>
							</div>
							<!--              <div class="mb-4">-->
							<!--                <input v-model="createAccount.username" type="text" class="form-control" placeholder="Enter User Name" name="username"-->
							<!--                       :class="{ 'is-invalid': typeSubmit && $v.createAccount.username.$error }" />-->
							<!--                <div v-if="typeSubmit && $v.createAccount.username.$error" class="invalid-feedback">-->
							<!--                  <span v-if="!$v.createAccount.username.required">User name is required.</span>-->
							<!--                </div>-->
							<!--              </div>-->
							<div class="mb-4 position-relative">
								<input v-model="createAccount.password" :type="type" class="form-control" placeholder="Enter password" name="password" :class="{ 'is-invalid': typeSubmit && $v.createAccount.password.$error }" />
								<span class="show-pwd" @click="showPassword"><i class="bx" :class="btnIcon"></i></span>
								<div v-if="typeSubmit && $v.createAccount.password.$error" class="invalid-feedback">
									<span v-if="!$v.createAccount.password.required">Password is required.</span>
								</div>
							</div>
							<div class="mb-4 position-relative">
								<input v-model="createAccount.confirm_password" :type="typeConfirm" class="form-control" placeholder="Confirm Password" name="confirm_password" :class="{ 'is-invalid': typeSubmit && $v.createAccount.confirm_password.$error }" />
								<span class="show-pwd" @click="showConfirmPassword"><i class="bx" :class="btnConfirmIcon"></i></span>
								<div v-if="typeSubmit && $v.createAccount.confirm_password.$error" class="invalid-feedback">
									<span v-if="!$v.createAccount.confirm_password.required">Confirm Password is required.</span>
									<span v-else-if="!$v.createAccount.confirm_password.sameAsPassword">This value should be the same.</span>
								</div>
							</div>
							<div class="mb-4 text-center">
								<b-button type="submit" variant="custom" :disabled="isDisable">Create Account</b-button>
							</div>

							<div class="mb-4 text-left">
								<span class="font-size-18">Please save your account information in a secure location. You will use this account to sign in each time you mentor or volunteer.</span>
							</div>
						</form>
					</div>
				</div>
			</div>
		</section>
		<b-modal id="beforeBegin" centered size="lg" title="Before You Begin Your Application!" title-class="font-18" hide-footer>
			<div class="row">
				<div class="col-12 text-center mb-5">
					<h5 class="text-start mb-3">You will need the information below in order to complete your application. Please have this information on hand before beginning your application:</h5>
					<ul>
						<li>
							<p class="text-start pb-0 font-size-16">Your contact information (full legal name, email, phone number, address, etc.)</p>
						</li>
						<li>
							<p class="text-start pb-0 font-size-16">
								Your Social Security Number for a background check (as required by the State of Minnesota) <br />
								<span class="d-block mt-2 text-muted" style="padding-left: 20px">SSNs are encrypted for security, submitted for a background check, and then removed. We do not store them in our database.</span>
							</p>
						</li>
						<li>
							<p class="text-start pb-0 font-size-16">
								Your Driver’s License Number for a driving record check <br />
								<span class="d-block mt-2 text-muted" style="padding-left: 20px">Mentors must have a valid driver’s license.</span>
							</p>
						</li>
						<li>
							<p class="text-start pb-0 font-size-16">
								The name, email address, and phone number of a person to serve as your Character Reference. <br />
								<span class="d-block mt-2 text-muted" style="padding-left: 20px">Your character reference can be a friend, colleague, pastor, or anyone who knows you well, EXCEPT someone who is related to you or to whom you are dating or engaged.</span>
							</p>
						</li>
						<li>
							<p class="text-start pb-0 font-size-16">Information and dates pertaining to any treatment programs you have attended and any criminal charges on record.</p>
						</li>
					</ul>
					<p class="fw-bold text-start pb-0">Please Note: You will be able to save your details as you progress through the application</p>
					<b-button type="button" @click="contactInfo" variant="custom">Begin Application</b-button>
				</div>
			</div>
		</b-modal>
		<b-modal id="becomeMentor" centered size="lg" title="Are You Also Interested In Becoming A Mentor?" title-class="font-18" hide-footer>
			<div class="row">
				<div class="col-12">
					<div class="d-flex justify-content-center mb-5">
						<b-button @click="becomeMentor" variant="custom">Yes</b-button>
						<b-button @click="contactInfo" variant="custom">No</b-button>
					</div>
				</div>
			</div>
		</b-modal>
		<Footer></Footer>
	</div>
</template>
